import { Typography, Button } from '@acme/web-ui-kit';
import { useTranslation } from 'react-i18next';
import Divider from 'src/components/Divider';

import styles from './ExpiredMessage.module.scss';

function ExpiredMessage() {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.icon} />

        <Typography variant="H4Normal" className={styles.description}>
          {t('payform.order_expired.title')}
        </Typography>
      </div>

      <Divider className={styles.divider} />
    </div>
  );
}

export default ExpiredMessage;
